<template>
  <div>
    <h2>SweetAlert2 Test Component</h2>
    <p>If you see a popup, try to close it by clicking outside, pressing Escape, or clicking the button.</p>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  name: 'SweetAlertTest',
  mounted() {
    Swal.fire({
      text: 'SweetAlert2 minimal test. Try to close me.',
      allowOutsideClick: true,
      allowEscapeKey: true,
      confirmButtonText: 'Got it!'
    });
  }
};
</script>

<style scoped>
div {
  padding: 24px 24px 48px;
  text-align: center;
}
</style> 